package services

data class LeadForm(
    val telegram: String = "",
    val timeline: String = "",
    val tripsPerYear: String = "",
    val comment: String = "",
)

data class LeadSubmission(
    val telegram: String,
    val timeline: String,
    val tripsPerYear: String,
    val comment: String,
    val bestScenario: String,
    val apecTotalRub: Long,
    val eVisaTotalRub: Long,
    val campaignId: String = "",
    val referralCode: String = "",
    val sessionId: String = "",
    val schemaVersion: String = "calculator-v1",
    val calculationSnapshotJson: String = "{}",
)

sealed class SubmissionResult {
    data object Submitted : SubmissionResult()
    data class Failed(val reason: String) : SubmissionResult()
}

interface LeadService {
    suspend fun submit(submission: LeadSubmission): SubmissionResult
}

class LocalOnlyLeadService : LeadService {
    override suspend fun submit(submission: LeadSubmission): SubmissionResult {
        return SubmissionResult.Failed("External lead endpoint is not configured")
    }
}

fun LeadForm.toLeadSubmission(bestScenario: String, apecTotalRub: Long, eVisaTotalRub: Long): LeadSubmission {
    return LeadSubmission(
        telegram = telegram.trim(),
        timeline = timeline.trim(),
        tripsPerYear = tripsPerYear.trim(),
        comment = comment.trim(),
        bestScenario = bestScenario,
        apecTotalRub = apecTotalRub,
        eVisaTotalRub = eVisaTotalRub,
    )
}

fun LeadForm.toEventDetail(): String {
    return "telegram=${telegram.sanitizeMetric()};timeline=${timeline.sanitizeMetric()};trips=${tripsPerYear.sanitizeMetric()};comment=${comment.sanitizeMetric()}"
}

fun LeadSubmission.toJsonPayload(): String {
    return "{" +
        "\"telegram\":\"${jsonEscape(telegram)}\"," +
        "\"timeline\":\"${jsonEscape(timeline)}\"," +
        "\"tripsPerYear\":\"${jsonEscape(tripsPerYear)}\"," +
        "\"comment\":\"${jsonEscape(comment)}\"," +
        "\"bestScenario\":\"${jsonEscape(bestScenario)}\"," +
        "\"apecTotalRub\":$apecTotalRub," +
        "\"evisaTotalRub\":$eVisaTotalRub," +
        "\"campaignId\":\"${jsonEscape(campaignId)}\"," +
        "\"referralCode\":\"${jsonEscape(referralCode)}\"," +
        "\"sessionId\":\"${jsonEscape(sessionId)}\"," +
        "\"schemaVersion\":\"${jsonEscape(schemaVersion)}\"," +
        "\"calculationSnapshot\":$calculationSnapshotJson" +
        "}"
}

fun LeadSubmission.toGoogleSheetsJsonPayload(token: String, submittedAt: String): String {
    return "{" +
        "\"token\":\"${jsonEscape(token)}\"," +
        "\"submittedAt\":\"${jsonEscape(submittedAt)}\"," +
        toJsonPayload().removePrefix("{")
}

private fun jsonEscape(value: String): String = buildString {
    value.forEach { char ->
        when (char) {
            '\\' -> append("\\\\")
            '"' -> append("\\\"")
            '\b' -> append("\\b")
            '\u000C' -> append("\\f")
            '\n' -> append("\\n")
            '\r' -> append("\\r")
            '\t' -> append("\\t")
            else -> {
                if (char < ' ') {
                    append("\\u")
                    append(char.code.toString(16).padStart(4, '0'))
                } else {
                    append(char)
                }
            }
        }
    }
}
